import { randomId } from 'shared/utils/randomId';
import { FiCheck } from '../react-icons/main';
import IconV2 from '../v2/IconV2.jsx';

const LabeledCheckbox = ({ className = '', title, label, checked = false, onChange, labelPosition = 'right', style = {} }) => {
  const uniqueId = randomId();

  return (
    <div className={`comp-labeled-checkbox ${className}`} onClick={() => onChange(!checked)} data-title={title || label} style={style}>
      {labelPosition === 'left' && <label htmlFor={uniqueId}>{label}</label>}
      <div className={`checkbox-wrapper ${checked ? 'checked' : ''}`} aria-checked={checked} role={'checkbox'}>
        <IconV2 icon={FiCheck} />
      </div>
      {labelPosition === 'right' && <label htmlFor={uniqueId}>{label}</label>}
    </div>
  );
};

export default LabeledCheckbox;
